/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `MapObjectRadius.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { MapObjectRadius } from "./MapObjectRadius";

import { MapObject } from "./MapObject";

export abstract class MapObjectRadiusModel {
    id: number;
    color: string;
    createdAt: Dayjs;
    mapObjectId: number;
    name: string | null;
    opacity: number;
    radius: number;
    showBorder: boolean;
    units: string;
    updatedAt: Dayjs;
    mapObject: MapObject | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        color: string,
        createdAt: Dayjs,
        mapObjectId: number,
        name: string | null,
        opacity: number,
        radius: number,
        showBorder: boolean,
        units: string,
        updatedAt: Dayjs,
        mapObject: MapObject | null | undefined
    ) {
        this.id = id;
        this.color = color;
        this.createdAt = createdAt;
        this.mapObjectId = mapObjectId;
        this.name = name;
        this.opacity = opacity;
        this.radius = radius;
        this.showBorder = showBorder;
        this.units = units;
        this.updatedAt = updatedAt;
        this.mapObject = mapObject;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): MapObjectRadius {
        const newObject = new MapObjectRadius(
            json["id"],
            json["color"],
            dayjs(json["created_at"]).tz(timezone),
            json["map_object_id"],
            json["name"],
            json["opacity"],
            json["radius"],
            json["show_border"],
            json["units"],
            dayjs(json["updated_at"]).tz(timezone),
            json["map_object"] == null ? json["map_object"] : MapObject.fromApiObject(json["map_object"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            color: this.color,
            created_at: this.createdAt,
            map_object_id: this.mapObjectId,
            name: this.name,
            opacity: this.opacity,
            radius: this.radius,
            show_border: this.showBorder,
            units: this.units,
            updated_at: this.updatedAt,
            map_object_attributes: this.mapObject?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): MapObjectRadius {
        const clone = Object.create(this) as MapObjectRadius;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
